// Componentes
import Background from "../elements/backgrounds/background";
import LabelLogo from '../elements/labels/labelLogo.js';
import LabelMenu from "../elements/labels/labelMenu.js";

function Main(){

    return (
        <main>
            <Background verImagen={true}>
                <LabelLogo/>
                <LabelMenu opcion={'contact'}/>
                <LabelMenu opcion={'work'}/>
                <LabelMenu opcion={'about'}/>
                <LabelMenu opcion={'instagram'}/>
            </Background>
        </main>
    );
}


export default Main;